import React from 'react';
import { Progress } from 'web-library';
import { useGetTransactionListing } from '../../../api-refactored/transaction/useGetTransactionDetailsListing';
import TransactionDetails from '../../../modules/transaction/@candidate/TransactionDetails';

const TransactionDetailsPage = () => {
  const { data, isLoading } = useGetTransactionListing({ candidateUuid: '' });

  return (
    <>
      {isLoading && <Progress />}
      {data && <TransactionDetails model={data} />}
    </>
  );
};

export default TransactionDetailsPage;
